<mat-tab-group animationDuration="0ms" dynamicHeight mat-align-tabs="center" class="phase-tabs"
    (selectedTabChange)="phaseChanged($event)">
    <mat-tab label="User Role Mapping">
        <ng-template matTabContent>
            <app-user-role-mapping></app-user-role-mapping>
        </ng-template>
    </mat-tab>
    <mat-tab label="Department Role Mapping">
        <ng-template matTabContent>
            <app-department-role-mapping></app-department-role-mapping>
        </ng-template>
    </mat-tab>
</mat-tab-group>
